/**
 * 기능 ID : COMVRF002-10MS
 * ASIS :
 */
import { useTranslation } from 'react-i18next';
import { AccordionUnder, BulletList, BulletListItem, Radio } from 'scbk-ui-web';
import { useAdditionalStore } from '../stores/useAdditionalStore';

const AdditionalARSStep1Component: React.FC = () => {
  // 다국어 처리
  const { t } = useTranslation();

  const { activateInfo, setSelectedARSTelNo } = useAdditionalStore();

  //   useEffect(() => {
  //     setSelectedARSTelNo({
  //       telNo: activateInfo?.phoneNo ?? '',
  //       maskTelNo: activateInfo?.maskPhoneNo ?? '',
  //     });
  //   }, [activateInfo]);

  return (
    <>
      <h2 className="page-heading-title mb-8">
        {t('AdditionalComponent.041', '전화번호를 선택해 주세요')}
      </h2>

      <div className="form-item-default-col">
        {activateInfo?.phoneNo && (
          <Radio
            key={`phoneNo${activateInfo?.phoneNo}`}
            variants="button-radio"
            id="phoneNo"
            label={activateInfo?.maskPhoneNo}
            value={activateInfo?.phoneNo}
            className="min-h-[64px] md:min-h-[72px]"
            defaultChecked={false}
            name="phoneNum"
            onClick={() => {
              setSelectedARSTelNo({
                telNo: activateInfo?.phoneNo ?? '',
                maskTelNo: activateInfo?.maskPhoneNo ?? '',
              });
            }}
          />
        )}
        {activateInfo?.homeTelNo && (
          <Radio
            key={`homeTelNo${activateInfo?.homeTelNo}`}
            variants="button-radio"
            id="homeTelNo"
            label={activateInfo?.maskHomeTelNo}
            value={activateInfo?.homeTelNo}
            className="min-h-[64px] md:min-h-[72px]"
            defaultChecked={false}
            name="phoneNum"
            onClick={() => {
              setSelectedARSTelNo({
                telNo: activateInfo?.homeTelNo ?? '',
                maskTelNo: activateInfo?.maskHomeTelNo ?? '',
              });
            }}
          />
        )}
        {activateInfo?.jobTelNo && (
          <Radio
            key={`jobTelNo${activateInfo?.jobTelNo}`}
            variants="button-radio"
            id="jobTelNo"
            label={activateInfo?.maskJobTelNo}
            value={activateInfo?.jobTelNo}
            className="min-h-[64px] md:min-h-[72px]"
            defaultChecked={false}
            name="phoneNum"
            onClick={() => {
              setSelectedARSTelNo({
                telNo: activateInfo?.jobTelNo ?? '',
                maskTelNo: activateInfo?.maskJobTelNo ?? '',
              });
            }}
          />
        )}
      </div>

      <AccordionUnder openTitle={t('AdditionalComponent.032', '알아두세요')}>
        <BulletList type="circle">
          <BulletListItem>
            {t(
              'AdditionalComponent.042',
              '등록된 전화번호가 2개 이상일 경우, 모바일뱅킹을 사용하는 단말과 다른 전화번호를 선택해 주세요. 단말기 보안정책에 따라 동일한 기기로는 전화(ARS) 인증이 원활하지 않을 수 있어요.',
            )}
          </BulletListItem>
          <BulletListItem>
            {t(
              'AdditionalComponent.043',
              '동일한 기기를 사용하여 인증하실 경우 [간편인증] 서비스를 이용해 주세요.',
            )}
          </BulletListItem>
        </BulletList>
      </AccordionUnder>
    </>
  );
};

export default AdditionalARSStep1Component;
